<!-- Main content -->
<!-- <div class="container-fluid width-alignment">
  <div class="row">
    <div class="row main stepitem compstep centro" [class.edit-mode]="isEditMode">
      <div class="col-sm-12 compswitch">
        <div class="row" [ngClass]="{ 'ord': catsolo !== 'solo' }">
          <div class="col-sm-1 col-xs-1"></div>
          <div class="col-sm-2 col-xs-3" [ngClass]="{ 'shift-right': catsolo === 'solo' }">
            <div class="steprow">
              <a (click)="changeTab('matter-info')" class="stepone stepideal"
                [ngClass]="{'yallow' : selectedTabItem=='matter-info','green': isCreate && matterInfo }">
                <img src="assets/img/stepone.svg" class="stepimg">
              </a>
            </div>
            <div>
              <p class="stptxt">Matter Info</p>
            </div>
          </div>
          

          <div class="col-sm-2 col-xs-3" *ngIf="!isMarketplace">
            <div class="steprow">
              <a (click)="changeTab('matter-clients')" class="stepone stepideal" 
                [ngClass]="{'yallow' : selectedTabItem=='matter-clients','green': isCreate && clientsData?.length>0}"
                [class.disabled]="isCreate && !matterInfo">
                <img src="assets/img/clients.svg" class="stepimg">
              </a>
            </div>
            <div *ngIf="product != 'corporate'">
              <p class="stptxt" style="margin-left: 0px;">Client(s)</p>
            </div>
            <div *ngIf="product == 'corporate'">
              <p class="stptxt" style="margin-left: -25px;">External Counsel(s)</p>
            </div>
          </div>

          <!-- <div class="col-sm-2 col-xs-3" *ngIf="product != 'corporate'">
            <div class="steprow">
              <a (click)="changeTab('matter-groups')" class="stepone stepideal"
                [ngClass]="{'yallow' :selectedTabItem == 'matter-groups','green':groups.length>0}"
                [class.disabled]="clients.length == 0 && !isMarketplace">
                <img src="assets/img/groups.svg" class="stepimg">
              </a>
            </div>
            <div *ngIf="product != 'corporate'">
              <p class="stptxt" style="margin-left: -20px;">Team Member(s)</p>
            </div>
            <div *ngIf="product == 'corporate'">
              <p class="stptxt" style="margin-left: -20px;">Department(s)</p>
            </div>
          </div> -->
        
          <!-- <div class="col-sm-2 col-xs-3">
            <div class="steprow">
              <a (click)="changeTab('matter-groups')" class="stepone stepideal"
                [ngClass]="{'yallow' :selectedTabItem == 'matter-groups','green': isCreate && groups.length>0}"
                [class.disabled]="!matterInfo">
                <img src="assets/img/groups.svg" class="stepimg">
              </a>
            </div>
            <div>
              <p class="stptxt" style="margin-left: -20px;">Department(s)</p>
            </div>
          </div> -->
          <!-- Groups - Corporate -->
          <!-- Clients - Corporate -->
          <!-- <div class="col-sm-2 col-xs-3" *ngIf="product == 'corporate'">
            <div class="steprow">
              <a (click)="changeTab('matter-clients')" class="stepone stepideal"
                [ngClass]="{'yallow' : selectedTabItem=='matter-clients','green': isCreate &&clientsData?.length>0 || tempClients?.length>0 || selectedClients}"
                [class.disabled]="groups.length == 0">
                <img src="assets/img/clients.svg" class="stepimg">
              </a>
            </div>
            <div>
              <p class="stptxt" style="margin-left: -25px;">External Counsel(s)</p>
            </div>
          </div> -->
          <!-- Clients - Corporate --
          
          <div class="col-sm-2 col-xs-3" *ngIf="catsolo !== 'solo'">
            <div class="steprow">
              <a (click)="changeTab('matter-team-member')" class="stepone stepideal"
                [ngClass]="{'yallow' : selectedTabItem=='matter-team-member','green': isCreate && (teammembersData.length>0) }"
               [class.disabled]="isCreate &&!matterInfo">
                <img src="assets/img/teams.svg" class="stepimg">
              </a>
            </div>
            <div>
              <p class="stptxt stepm">Team Member(s)</p>
            </div>
          </div>
          <div class="col-sm-2 col-xs-3">
            <div class="steprow">
              <a (click)="changeTab('matter-documents')" class="stepone stepideal"
                [ngClass]="{'yallow' : selectedTabItem=='matter-documents','green': isCreate && docsData.length>0 }"
                [class.disabled]="isCreate && !matterInfo">
                <img src="assets/img/documents.svg" class="stepimg">
              </a>
            </div>
            <div>
              <p class="stptxt">Document(s)</p>
            </div>
          </div>
          <div class="col-sm-1 col-xs-1"></div>
        </div>
      </div>
    </div>

  </div>
</div> -->


<div class="hole">
<!-- Step progress bar -->
<div class="stepper-wrap">
  <div class="stepper">

    <!-- Step 1: Matter Info -->
    <div class="step-item" (click)="changeTab('matter-info')">
      <div class="step-circle"
        [class.done]="isCreate && matterInfo"
        [class.active]="selectedTabItem === 'matter-info'">
        <span *ngIf="isCreate && matterInfo"><img src="assets/img/groups.svg" class="stepimg"></span>
        <span *ngIf="!(isCreate && matterInfo)"><img src="assets/img/groups.svg" class="stepimg"></span>
      </div>
      <div class="step-label"
        [class.active]="selectedTabItem === 'matter-info'"
        [class.done]="isCreate && matterInfo">
        Matter Info
      </div>
    </div>

    <div class="step-connector" [class.done]="isCreate && matterInfo"></div>

    <!-- Step 2: Clients -->
    <div class="step-item" (click)="changeTab('matter-clients')"
      [class.disabled]="isCreate && !matterInfo" *ngIf="!isMarketplace">
      <div class="step-circle"
        [class.done]="isCreate && clientsData?.length > 0"
        [class.active]="selectedTabItem === 'matter-clients'">
        <span *ngIf="isCreate && clientsData?.length > 0"><img src="assets/img/clients.svg" class="stepimg"></span>
        <span *ngIf="!(isCreate && clientsData?.length > 0)"> <img src="assets/img/clients.svg" class="stepimg"></span>
      </div>
      <div class="step-label"
        [class.active]="selectedTabItem === 'matter-clients'"
        [class.done]="isCreate && clientsData?.length > 0">
        {{ product === 'corporate' ? 'External counsel(s)' : 'Client(s)' }}
      </div>
    </div>

    <div class="step-connector" [class.done]="isCreate && clientsData?.length > 0" *ngIf="catsolo !== 'solo'"></div>

    <!-- Step 3: Team Members -->
    <div class="step-item" (click)="changeTab('matter-team-member')"
      [class.disabled]="isCreate && !matterInfo" *ngIf="catsolo !== 'solo'">
      <div class="step-circle"
        [class.done]="isCreate && teammembersData.length > 0"
        [class.active]="selectedTabItem === 'matter-team-member'">
        <span *ngIf="isCreate && teammembersData.length > 0"><img src="assets/img/teams.svg" class="stepimg"></span>
        <span *ngIf="!(isCreate && teammembersData.length > 0)"><img src="assets/img/teams.svg" class="stepimg"></span>
      </div>
      <div class="step-label"
        [class.active]="selectedTabItem === 'matter-team-member'"
        [class.done]="isCreate && teammembersData.length > 0">
        Team member(s)
      </div>
    </div>

    <div class="step-connector" [class.done]="isCreate && teammembersData.length > 0"></div>

    <!-- Step 4: Documents -->
    <div class="step-item" (click)="changeTab('matter-documents')"
      [class.disabled]="isCreate && !matterInfo">
      <div class="step-circle"
        [class.done]="isCreate && docsData.length > 0"
        [class.active]="selectedTabItem === 'matter-documents'">
        <span *ngIf="isCreate && docsData.length > 0"><img src="assets/img/documents.svg" class="stepimg"></span>
        <span *ngIf="!(isCreate && docsData.length > 0)"><img src="assets/img/documents.svg" class="stepimg"></span>
      </div>
      <div class="step-label"
        [class.active]="selectedTabItem === 'matter-documents'"
        [class.done]="isCreate && docsData.length > 0">
        Document(s)
      </div>
    </div>

  </div>
</div>
<!-- Step progress bar -->

<div *ngIf="selectedTabItem == 'matter-info'">
  <matter-info [data]="matterInfo" (childButtonEvent)="receiveMatterIngo($event)" [matterId]="matterId"></matter-info>
</div>
<div *ngIf="selectedTabItem == 'matter-clients'">
  <matter-clients [data]="InfotoOtherTabs" [clients]="clients" [matterId]="matterId" [groups]="groups" [clientsData]="clientsData"
    [clientsWereSaved]="clientsWereSaved" (temporaryClientsEvent)="temporaryClients($event)" (clientsSaved)="onClientsSaved($event)"
    (selectedClientsEvent)="selectedClient($event)"></matter-clients>
</div>
<div *ngIf="selectedTabItem == 'matter-groups'">
  <matter-groups [data]="InfotoOtherTabs" [groups]="groups" [clients]="clients" [matterId]="matterId" (groupsSaved)="onGroupsSaved($event)"
    (selectedGroupsEvent)="selectedGroup($event)"></matter-groups>
</div>
<div *ngIf="selectedTabItem == 'matter-team-member'">
  <matter-team-members [data]="InfotoOtherTabs" [teammembers]="teammembers" [matterId]="matterId" [groups]="groups" [clients]="clients" 
  [tmsWereSaved]="tmsWereSaved" (tmsSaved)="onTmsSaved($event)"
  (selectedTmsEvent)="selectedTeammemberes($event)"></matter-team-members>
</div>
<div *ngIf="selectedTabItem == 'matter-documents'">
  <matter-documents [data]="InfotoOtherTabs" [groups]="groups" [docsData]="docsData" [clients]="clients" [matterId]="matterId" [corporate]="corpData" (docsSaved)="onDocsSaved($event)"
   [docsWereSaved]="docsWereSaved" (selectedDocumentsEvent)="selectedDocuments($event)"></matter-documents>
</div>

</div>
